import { render, staticRenderFns } from "./InstagramFeedCreative.vue?vue&type=template&id=44230aa8&scoped=true&"
import script from "./InstagramFeedCreative.vue?vue&type=script&lang=ts&"
export * from "./InstagramFeedCreative.vue?vue&type=script&lang=ts&"
import style0 from "./InstagramFeedCreative.vue?vue&type=style&index=0&id=44230aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44230aa8",
  null
  
)

export default component.exports